import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/drupal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M319.5 114.7C297.3 100.7 276 95.2 254.8 81.2 241.8 72.4 223.5 51.2 208.3 32.9 205.6 62.2 196.8 74.1 186.3 82.4 165 99.4 151.5 104.6 132.8 114.7 117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294 416 181.7 333 123 319.5 114.7zM322 440.3C301.9 460.4 231.9 469 205.3 444.5 200.5 439.7 205.6 432.5 211.8 432.5 211.8 432.5 228.8 445.8 263.3 445.8 290.3 445.8 309.3 438.1 317.8 431.8 323.9 427.2 326.2 436.1 322 440.3zM267.5 387.7C276.2 384.1 296.5 383.9 304.3 389 308.4 391.8 320.4 407.8 310.5 412.7 302.1 416.9 309.3 397 284 397 269.3 397 264.5 402.2 257.3 408 250.3 414 247.5 416 245.1 412.7 239.1 404.5 261 390.4 267.5 387.7zM360 405C344.8 404 314.5 356.2 295 355.5 264.1 354.6 190.9 436.2 133.7 397.5 94.9 370.9 119.1 292.7 185.5 292.3 235 291.8 269.3 341.3 294 340.8 315.3 340.5 355.8 299 375.8 299 424.5 299 399.1 408.3 360 405z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/drupal.js
// module id = 6/VG
// module chunks = 144